import type { ReactNode } from "react";
import { describeError, ApiError } from "../api/errors";
import { Button } from "react-aria-components";

export function Loading({ label = "Loading" }: { label?: string }) {
  return (
    <div className="state loading" role="status" aria-live="polite">
      <span className="spinner" aria-hidden />
      <span>{label}…</span>
    </div>
  );
}

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const requestId = error instanceof ApiError ? error.requestId : null;
  return (
    <div className="state error" role="alert">
      <p>{describeError(error)}</p>
      {onRetry && (
        <Button className="button" onPress={onRetry}>
          Try again
        </Button>
      )}
      {requestId && (
        <details>
          <summary>Details</summary>
          <p>
            {error instanceof Error ? error.message : ""} <br />
            Request ID: <code>{requestId}</code>
          </p>
        </details>
      )}
    </div>
  );
}

export function Empty({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className="state empty">
      <h2>{title}</h2>
      {children}
    </div>
  );
}
